<template>
  <div class="contact-page">

    <div class="content" @click="dropDownOpen = false">

      <div class="contact-team first">
          <div class="contact-card">
            <div class="details">
              <h4>Renee <span>Hambley</span></h4>
              <h5>founder</h5>
              <p>"I love these buildings, growing closer to the people within them has been a bonus."</p>
            </div>
            <a class="email" href="mailto:renee@therenees.com">renee@therenees.com</a>
          </div>

          <div class="contact-card">
            <img src="/static/renee.jpg">
          </div>

          <div class="contact-card headline">
            <!-- <h2>Be In Touch</h2> -->
          </div>
      </div>

      <div class="contact-team second">

          <div class="contact-card mobileonly">
            <img src="/static/renee.jpg">
            <div class="details">
              <h4>Renee <span>Hambley</span></h4>
              <h5>founder</h5>
              <p>"I love these buildings, growing closer to the people within them has been a bonus."</p>
            </div>
            <a class="email" href="mailto:renee@therenees.com">renee@therenees.com</a>
          </div>

          <div class="contact-card">
            <img src="/static/alexis.jpg">
            <div class="details">
              <h4>Alexis <span></span></h4>
              <h5>Property Director</h5>
              <a class="email" href="mailto:alexis@therenees.com">alexis@therenees.com</a>
            </div>
          </div>

          <div class="contact-card">
            <img src="/static/cristina.jpg">
            <div class="details">
              <h4>Cristina <span></span></h4>
              <h5>Property Production Assistant</h5>
              <a class="email" href="mailto:cristina@therenees.com">cristina@therenees.com</a>
            </div>
          </div>

          <!-- <div class="contact-card">
            <img src="/static/kayleigh.jpg">
            <div class="details">
              <h4>Kayleigh <span></span></h4>
              <h5>property production assistant</h5>
              <a class="email" href="mailto:kayleigh@therenees.com">kayleigh@therenees.com</a>
            </div>
          </div> -->

          <div class="contact-card">
            <img src="/static/ivan.jpg">
            <div class="details">
              <h4>Ivan <span></span></h4>
              <h5>content director</h5>
              <a class="email" href="mailto:ivan@therenees.com">ivan@therenees.com</a>
              <!-- <a class="email" href="mailto:creative@therenees.com">creative@therenees.com</a> -->
            </div>
          </div>

          <div class="contact-card">
            <img src="/static/paula2.jpg">
            <div class="details">
              <h4>Paula <span></span></h4>
              <h5>site rep</h5>
              <a class="email" href="mailto:paula@therenees.com">paula@therenees.com</a>
            </div>
          </div>

          <div class="contact-card">
            <img src="/static/raffa.jpg">
            <div class="details">
              <h4>Raffa <span></span></h4>
              <h5>site rep</h5>
              <a class="email" href="mailto:raffa@therenees.com">raffa@therenees.com</a>
            </div>
          </div>

          <div class="contact-card">
            <img src="/static/julie.jpg">
            <div class="details">
              <h4>Julie <span><!-- Skrupa --></span></h4>
              <h5>site rep</h5>
              <a class="email" href="mailto:julie@therenees.com">julie@therenees.com</a>
            </div>
          </div>

          <div class="contact-card">
            <img src="/static/headshot-placeholder2.jpg">
            <div class="details">
              <h4>Fernand <span></span></h4>
              <h5>photographer</h5>
              <a class="email" href="mailto:content@therenees.com">content@therenees.com</a>
            </div>
          </div>

      </div>
      <div class="contact-inner">
         <div class="contactinfo">
           <img src="../assets/icon.png">
           <p>
             <strong>Address</strong>
              756 S Broadway<br>
              Suite 709<br>
              Los Angeles, CA 90014
           </p>
         </div><!-- /.contactinfo -->

         <div class="contactform">
           <template v-if="!formSubmitted">


              <div class="general-form">
                <h3>Reach out to one of The Renees to book a location or with any questions regarding your search</h3>
                <form ref="generalform" @submit.prevent="formSubmit('generalform')">
                  <div class="form-left">
                    <input type="text" name="firstname" placeholder="First Name" tabindex="1" required>
                    <input type="email" name="email" placeholder="Email" tabindex="3" required>
                  </div>
                  <div class="form-right">
                    <input type="text" name="lastname" placeholder="Last Name" tabindex="2" required>
                    <input type="text" name="phone" placeholder="Phone" tabindex="4">
                  </div>
                  <textarea name="message" placeholder="Enter your message here" tabindex="5" required></textarea>

                  <div ref="recaptcha" class="recaptcha"></div>

                  <button type="submit" v-if="!formLoading">Send It</button>
                  <button type="submit" v-else disabled="disabled">Sending..</button>
                </form>
              </div><!-- /general-form -->

           </template>
           <template v-else>
              <h1 class="received">Submission Received</h1>
              <p>Thank you! We'll get back to you as soon as possible.</p>
           </template>
         </div><!-- /.contactform -->
      </div>

      <div class="bottom-section">
      </div>


    </div><!-- /.content -->

  </div><!-- /.contact-page -->
</template>

<script>
export default {
  name: 'ContactPage',
  data () {
    return {
      selectedForm: 'Book a Property',
      dropDownOpen: false,
      formSubmitted: false,
      formLoading: false,
      sitekey: '6Lfr0owsAAAAABp_7N0xVdXR4A-L2wHs5lXZKyzk',
      recaptchaToken: null,
      widgetId: null
    }
  },
  mounted () {
    const checkGrecaptcha = setInterval(() => {
      if (window.grecaptcha && window.grecaptcha.render) {
        clearInterval(checkGrecaptcha)
        console.log('captcha loaded')
        this.$nextTick(() => {
          try {
            console.log(this.$refs.recaptcha)
            this.renderCaptcha()
          } catch (e) {
            console.error('Render failed:', e)
          }
        })
      }
    }, 100)
  },
  created () {
    document.title = 'Contact Us - The Renees'
    document.head.querySelector('meta[name=description]').content = 'Contact our experienced scouting team to help find and book the perfect location for your production'
  },
  methods: {
    renderCaptcha () {
      if (window.grecaptcha && this.$refs.recaptcha) {
        this.widgetId = window.grecaptcha.render(this.$refs.recaptcha, {
          'sitekey': '6Lfr0owsAAAAABp_7N0xVdXR4A-L2wHs5lXZKyzk',
          'callback': (token) => {
            this.recaptchaToken = token
          }
        })
      }
    },
    formSubmit (formName) {
      if (!this.recaptchaToken) {
        alert('Please complete the reCAPTCHA')
        return
      }
      this.formLoading = true
      var formData = new FormData(this.$refs[formName])
      var fields = {}
      formData.forEach(function (value, key) { fields[key] = value })
      fields.formname = formName
      this.$http.post(this.$root.apiurl + 'contact', fields).then(response => {
        this.formSubmitted = true
      }, response => {
        console.log(response.statusText)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/_mixins.scss";

.content {

  .contact-inner {
    max-width: 1120px;
    margin: 0px auto;
    padding: 1em 1em;
    @include bp(most) {
      padding: 4em 1em;
    }
  }
}

.contact-team {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
  flex-wrap: wrap;
  max-width: 1045px;
  margin: 0 auto;
  padding: 1.5em;
  box-sizing: border-box;
  @include bp(most) {
    flex-direction: row;
  }
  .contact-card {
    margin-bottom: 1em;
    @include bp(most) {
      width: 33%;
      margin-bottom: 1em;
    }
    img {
      width: 70%;

    }
    &.mobileonly {
      display: block;
      @include bp(most) {
        display: none;
      }
    }
    @include bp(mobile) {
      &:nth-child(even) {
        text-align: right;
      }
    }
  }
  .details {
    background: linear-gradient(90deg, rgba(161,99,165,1) 0%, rgba(161,99,165,.4) 100%);
    position: relative;
    top: -70px;
    left: 25px;
    width: calc(100% - 30px);
    color: #FFF;
    font-family: $futura;
    box-sizing: border-box;;
    padding: 8px 10px;
    margin-bottom: -60px;
    h4 {
      margin: .25em 0 0;
      font-family: $lulo;
      letter-spacing: -3px;
      font-size: 22px;
      line-height: 22px;
      span {
        font-size: 14px;
        display: inline-block;
        margin-left: -5px;
      }
      @include bp(most) {
       font-size: 22px;
       line-height: 22px;
       span {
         font-size: 12px;
       }
      }
      @include bp(medlarge) {
       font-size: 30px;
       line-height: 30px;
       span {
         font-size: 16px;
         margin-left: -10px;
       }
      }

    }
    h5 {
      margin: 0 0 .25em;
      color: #ffca37;
      font-size: 16px;
      display: inline-block;
      vertical-align: top;
      /* width: 30%; */
      font-weight: 400;
      letter-spacing: -.04em;
      text-transform: lowercase;
      @include bp(most) {
        font-size: 12px;
        /* width: 26%; */
      }
      @include bp(medlarge) {
        font-size: 18px;
        /* width: 30%; */
      }
    }
    p {
      display: inline-block;
      vertical-align: middle;
      font-size: 11px;
      width: 71%;
      line-height: 1;
      font-weight: 400;
      margin: 0;
      height: 4em;
      @include bp(medlarge) {
        width: 67%;
        font-size: 12px;
        line-height: 1.3;
      }
    }
  }
  a.email {
    color: #FFF;
    text-decoration: none;
    letter-spacing: 1px;
    display: block;
    /* margin-left: 35px; */
  }
  &.first {
    align-items: center;
    @include bp(mobile) {
      padding: 0;
      .contact-card {
        display: none;
      }
      .contact-card.headline {
        display: block;
      }
    }
    .details {
      background: none;
      color: #000;
      position: static;
      margin-bottom: .75em;
      h5 {
        color: $purple;
      }
    }
    a {
      @include bp(medlarge) {
        margin-left: 76px;
      }
    }
  }
  .headline {
    h2 {
      font-family: $lulo;
      font-weight: 200;
      letter-spacing: -7px;
      font-size: 24px;
      @include bp(most) {
        font-size: 48px;
        transform: scaleX(0.9);

      }
    }
  }

}



  .contactinfo {
    vertical-align: top;
    font-family: $futura;
    @include bp(most) {
      display: inline-block;
      width: 20%;
      padding: 2em 0;
    }
    img {
      width: 32px;
      height: 27px;
      display: block;
      @include bp(most) {
        display: block;
        width: 68px;
        height: 59px;
      }
    }
    p {
      font-family: $futura;
      color: $notblack;
      display: inline-block;
      vertical-align: top;
      width: 47%;
      font-size: .75em;
      margin-bottom: .5em;
      font-weight: 500;
      @include bp(most) {
        display: block;
        width: 100%;
        margin-bottom: .75em;
        font-size: 1em;
      }
      strong {
        text-transform: uppercase;
        font-size: 22px;
        font-family: $lulo;
        display: block;
        padding: .5em 0;
      }
    }
    a {
      color: $notblack;
      text-decoration: none;
    }
  }
  .contactform {
    font-family: $futura;
    @include bp(most) {
      display: inline-block;
      vertical-align: top;
      width: 74%;
      padding-left: 6.5%;
      box-sizing: border-box;
    }
    h3 {
      font-size: 22px;
      font-weight: 400;
    }
  }

.bottom-section {
  background: linear-gradient(90deg, rgba(124,72,128,1) 0%, rgba(244,199,50,1) 100%);
  height: 8em;
  text-align: center;
  /* display: none; */
  margin-bottom: -4px;
  @include bp(most) {
    display: block;
  }
}

.dropdown {
  font-size: 1.5em;
  font-weight: 300;
  cursor: pointer;
  margin-bottom: 1em;
  position: relative;
  @include noselect();
  @include bp(most) {
    font-size: 2.5em;
  }
  .selected {
    position: relative;
    border-bottom: 2px solid #979797;
    padding: .5em 0;
    @include bp(most) {
      width: 14.5em;
      padding: .25em 0;
    }
    i {
      position: absolute;
      right: 4px;
      top: 16px;
      @include bp(most) {
        top: 22px;
      }
    }
    &:hover {
      i {

      }
      border-bottom: 2px solid $notblack;
    }
    &.greyed {
      color: #979797;
    }
  }
  ul {
    margin: 0px;
    padding: 0px;
    list-style-type: none;
    position: absolute;
    width: 100%;
    box-sizing: border-box;
    @include bp(most) {
      width: 14.5em;
    }
    li {
      padding: .5em .25em;
      background: #f3f3f3;
      border-bottom: 2px solid #979797;
      @include bp(most) {
        padding: .25em;
      }
      &:hover {
        background: $yellow;
      }
    }
  }
}

.list-form {
  padding-bottom: 25em;
}

p {
  font-family: $futura;
  line-height: 1.5;
}

.form-left {
  @include bp(most) {
    display: inline-block;
    vertical-align: top;
    width: 45%;
    margin-right: 9%;
  }
}
.form-right {
  @include bp(most) {
    display: inline-block;
    vertical-align: top;
    width: 45%;
  }
}

form {
  padding-top: 1em;
}

.sidebyside {
  height: 5.125em;
  clear: both;
  & > div {
    width: 49%;
    display: inline-block;
    &:last-child {
      margin-left: .5%;
    }
  }
}

  label {
    display: block;
    font-family: $futura;
    color: #8A8A8A;
    margin: .25em 0;
  }
  input[type=text], input[type=email], input[type=date], input[type=number] {
    font-family: $futura;
    display: block;
    text-align: left;
    width: 100%;
    outline: none;
    padding: .75em;
    font-size: 1em;
    box-sizing: border-box;
    margin-bottom: .75em;
    border: 0px none;
    border-bottom: 1px solid #000;
    color: #000;
    background: #FFF;
    &::-webkit-datetime-edit-year-field:not([aria-valuenow]),
    &::-webkit-datetime-edit-month-field:not([aria-valuenow]),
    &::-webkit-datetime-edit-day-field:not([aria-valuenow]) {
        color: transparent;
    }
    &::placeholder {
      color: #333;
    }
    &:focus {
      background: #FFF;
    }
  }

  select {
    font-family: $futura;
    display: block;
    text-align: left;
    width: 100%;
    outline: none;
    height: 3em;
    font-size: 1em;
    box-sizing: border-box;
    margin-bottom: .75em;
    border: 1px solid #7D7D7D;
    border-radius: 3px;
    color: $notblack;
    background: #FBFBFB;
    padding-left: .75em;
    -webkit-appearance: textfield;
    &:required:invalid {
      color: #CFCFCF;
    }
  }
  .radios {
    padding: .75em 0;
    input {
      display: inline-block;
    }
    label {
      display: inline-block;
      color: $notblack;
      margin-right: 1em;
    }
  }
  textarea {
    font-family: $futura;
    display: block;
    text-align: left;
    width: 100%;
    outline: none;
    padding: .75em;
    font-size: 1em;
    box-sizing: border-box;
    margin-bottom: .75em;
    border: 0px none;
    border-bottom: 1px solid #000;
    color: #000;
    background-color: #FFF;
    height: 10em;
    &:focus {
      background-color: #FFF;
    }
    &::placeholder {
      color: #333;
    }
  }
  .scout-form textarea {
    height: 8.825em;
  }
  button {
    background: #FFF;
    width: 100%;
    outline: none;
    border: 0px none;
    border-radius: 3px;
    font-family: $montserrat;
    color: #000;
    font-weight: 300;
    font-size: 1.25em;
    padding: .5em 1.5em;
    cursor: pointer;
    box-sizing: border-box;
    line-height: 1.4;
    &:disabled {
      background: #7d7d7d;
    }
    &:hover {
      background: $purple;
      color: #FFF;
    }
  }

  h1.received {
    font-weight: 300;
    @include bp(most) {
      font-size: 36px;
    }
  }
  div.recaptcha {
    padding-bottom: 1em;
  }
</style>



// WEBPACK FOOTER //
// ContactPage.vue?102991ee